import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Link,
  Stack,
  Alert,
  AlertTitle,
  Button,
} from "@mui/material";
import Input from "../Base/Input";
import SubmitButton from "../common/SubmitButton";
import { useTranslation } from "react-i18next";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import configData from "../../Config";
import { apis } from "../../services/apiService";
import {
  VerifyMobile,
  calculateUserBlockTimer,
  constant,
  convertSEcToMin,
  login,
  refreshCacheAndReload,
} from "../../utils/utils";
import useSelector from "../../store/selector";
import styles from "../../Style/Modules/login.module.css";
import "../../Style/Theme/index.css";
import { encryptApiData } from "../../utils/apiEncryption";
import AlertPopup from "../common/AlertPopup";
import ContainerForm from "../../containers/ContainerForm";
import ContainerSubmitButton from "../common/ContainerSubmitButton";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import "../../Style/Theme/index.css";
import loginImg from "./tyger_logo_animation_loader.gif";

export default function LoginForm() {
  const [queryParameters] = useSearchParams();
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [countTimer, setCountTimer] = useState(0);
  const { Source, Anchor, Program, SalesLogin } = useParams();
  const navigate = useNavigate();
  const [mobileErr, setMobileErr] = useState("");
  const [mobile, setmobile] = useState("");
  const [finalErr, setFinalErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  let errors = {
    1: t("Enter valid mobile number"),
    2: t("Invalid user.Please enter correct mobile number or Signup."),
    3: t("Mobile number should not start with 0"),
  };
  const handleChange = (e) => {
    setmobile(e?.target?.value);
    setCountTimer(0);
    if (e?.target?.value && !VerifyMobile(e?.target?.value)) {
      parseInt(e.target.value.charAt(0)) === 0
        ? setMobileErr(errors[3])
        : setMobileErr(errors[1]);
    } else {
      setMobileErr("");
    }
  };

  const callSubmitFun = async () => {
    if (SalesLogin) {
      let data = {
        mn: mobile,
        // AppId: result?.data,
        em: "",
        isEmail: false,
        anchor: Anchor,
        program: Program,
        source: Source,
      };
      navigate("/otp_p", { state: data });
    } else {
      try {
        setLoading(true);
        const reqData = {
          mn: mobile,
          src: Source,
          anch: Anchor,
          pr: Program,
        };
        let resp = await apis.postApi(configData.API_URL + "OTP/SendOTP_N", {
          request: encryptApiData(reqData),
        });
        let result = await resp?.json();
        if (resp.status === 200) {
          setLoading(false);
          let data = {
            mn: mobile,
            // AppId: result?.data,
            em: "",
            isEmail: false,
            anchor: Anchor,
            program: Program,
            source: Source,
          };
          navigate("/otp_p", { state: data });
        }
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        const errormessage = errorResult?.statusMessage
        console.log("errorResult = ", errorResult);
        // const errormessage = JSON.parse(error?.statusMessage);
        console.log("errormessage = ", errormessage);
        console.log("errormessage = ", errormessage);
        if (
          errormessage &&
          errormessage.startsWith("You Have Exceed the Limit")
        ) {
          setFinalErr(errormessage);
          return;
        }
        else{
           let data = {
          mn: mobile,
          // AppId: result?.data,
          em: "",
          isEmail: false,
          anchor: Anchor,
          program: Program,
          source: Source,
        };
        navigate("/otp_p", { state: data });
        }
      }
      // finally {
      //   let data = {
      //     mn: mobile,
      //     // AppId: result?.data,
      //     em: "",
      //     isEmail: false,
      //     anchor: Anchor,
      //     program: Program,
      //     source: Source,
      //   };
      //   navigate("/otp_p", { state: data });
      // }
    }
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    let storedData = getRecoilVal(constant.atomsName.USER_BLOCKER);
    let finalVal = await calculateUserBlockTimer(
      mobile,
      storedData,
      setCountTimer,
      setRecoilVal,
      Source,
      Anchor,
      Program
    );
    if (!finalVal.anchorProgramMatched) {
      await callSubmitFun();
    } else if (finalVal.timeDef <= 0 && finalVal.anchorProgramMatched) {
      await callSubmitFun();
    }
  };

  let handleSignUp = async (e) => {
    setLoading(true);
    navigate("/signup", {
      state: { source: Source, anchor: Anchor, program: Program },
    });
    setLoading(false);
  };

  const autoLoginForSalesPerson = () => {
    const queryParamMobile = queryParameters.get("mn");
    const queryParamOtp = queryParameters.get("otp");
    const data = {
      mn: queryParamMobile,
      em: "",
      isEmail: false,
      anchor: Anchor,
      program: Program,
      source: Source,
      queryParamOtp: queryParamOtp,
    };
    navigate("/otp_p", { state: data });
  };

  useEffect(() => {
    async function fun() {
      refreshCacheAndReload();
      const loginData = {
        anchor: Anchor,
        program: Program,
        source: Source,
        mobileNum: mobile,
        loginLogoutVal: constant.LOGOUT_VALUE,
      };
      setRecoilVal(constant?.atomsName?.USER_DETAIL, await login(loginData));
      if (queryParameters.get("mn") && queryParameters.get("otp")) {
        // it will call when login URL get from admin
        autoLoginForSalesPerson();
      }
    }
    fun();
  }, []);

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <>
      {/* <ContainerForm
        component="form"
        noValidate
        id="loginForm"
        autoComplete="off"
        onSubmit={handleSubmit}
        className={`${styles.loginFormBox}`}
        title={"login"}
        subtitle={"Enter your mobile number"}
        icon={"/assets/terms.svg"}
      > */}
      {/* <Box sx={{ position: "absolute", bottom: "55%" }}> */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          // p: "2px 2px",
          // mb: "10px",
          // top: "20%",
          // width: 400,
          marginTop: "300px",
          bgcolor: "#e9e9e9",
          position: "absolute",
          backgroundColor: "#29417c",
        }}
      >
        {/* <Input
          type="tel"
          autoComplete="off"
          name="phoneNumber"
          value={mobile}
          error={mobileErr}
          label="Mobile number"
          onChange={handleChange}
          mb={1}
        /> */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <Box>
            <Input
              className="loginPage inputbg_Th"
              sx={{ width: "280px", color: "white" }}
              type="tel"
              autoComplete="off"
              name="phoneNumber"
              value={mobile}
              error={mobileErr}
              label="Mobile number"
              onChange={handleChange}
              mb={1}
            />
          </Box>

          <IconButton
            aria-label="directions"
            disabled={!mobile || mobileErr}
            type="submit"
          >
            <DirectionsIcon
              sx={{
                fontSize: 45,
                // mt: 1,
                color: !mobile || mobileErr ? "#666666" : "#a6ce39",
              }}
            />
          </IconButton>
        </Box>
        <Box sx={{ mx: 4, mt: -1.5 }}>
          {mobileErr && (
            <Box ml={0}>
              <Typography variant="p" color="subtitle" className="errorMsg_Th">
                {mobileErr}
              </Typography>
            </Box>
          )}

          {countTimer > 0 && (
            <Box className="errorMsg_Th">
              {mobile.length === 10 &&
                countTimer > 0 &&
                // localStorage.getItem("blocker") !== null &&
                `You Have Exceed the Limit of verifying OTP, Please wait for ${convertSEcToMin(
                  countTimer
                )} minute`}
            </Box>
          )}

          {loading && (
            <Backdrop ax="center">
              <img
                src={loginImg}
                style={{
                  backgroundColor: "#072b8240",
                  // "#072b822b",
                  // "#4c69b1",
                  // opacity: "0.8",
                  width: "200px",
                  height: "150px",
                  marginLeft: "25%",
                  borderRadius: "10px",
                }}
              />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
            </Backdrop>
          )}
        </Box>
      </Box>
      {/* </ContainerForm> */}
      <Box
        // className={styles.signupBox}
        sx={{
          position: "relative",
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 700,
            mb: 1,
            color: "#868787",
            textAlign: "center",
          }}
        >
          New User?
        </Typography>
        {/* <img src="/assets/message.svg" alt="message" /> */}
        <Link onClick={handleSignUp}>
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
              bgcolor: "#a6ce39",
              width: "180px",
              height: "32px",
            }}
          >
            Sign Up
          </Button>
          {/* <Typography
            variant="p"
            color="info"
            className={`${styles.signupTypo} typo_Th`}
          >
            {t("SIGN UP")} */}
          {/* </Typography> */}
        </Link>
      </Box>
      {/* </Box> */}
    </>
  );
}
